import {type ReactAction} from '@netx/core/bootstrap';
import {faTimes} from '@fortawesome/pro-solid-svg-icons';
import {CART_CURRENT_ACTION_LABELS} from '@netx/core-cart-current/locales';
import {CATEGORY_EVENT, OrganizeAssetsAction} from '@netx/core-category-next';
import {canOrganizeAsset} from '../enablers';
import {type IAsset} from '../schema';

/**
 * Remove asset from folder
 * @param params
 * @returns Action
 */
export const assetActionCategorizeRemove = (
	asset: IAsset,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'asset-categorize-remove',
	cb: () =>
		dispatcher.trigger(CATEGORY_EVENT.SHOW_ORGANIZE_ASSETS, {
			asset,
			action: OrganizeAssetsAction.REMOVE,
		}),
	enableTest: () => asset.categories.length > 1 && canOrganizeAsset(asset),
	icon: faTimes,
	get label() {
		return CART_CURRENT_ACTION_LABELS.CATEGORIZE_REMOVE;
	},
	...params,
});

export default assetActionCategorizeRemove;
